var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__add--system icon--style--outline icon--size--small",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.25 7.25h-5.5v-5.5a.75.75 0 00-1.5 0v5.5h-5.5a.75.75 0 000 1.5h5.5v5.5a.75.75 0 001.5 0v-5.5h5.5a.75.75 0 000-1.5z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }